var cart = new function(){

  var me = this;

  this.popup = {
    "show": function(code,msg){
      $("[data-cart-popupmsg]").html(msg);
      $.magnificPopup.open({
        items: {
          src: '.popupForm--cart'
        },
        type:'inline',
        midClick: true,
        removalDelay: 500,
        mainClass: 'mfp-fade',
        callbacks: {
            beforeOpen: function() {
              this.st.mainClass = $(this).removeClass('success').removeClass('error').addClass(code?'success':'error');
            }
        },
      });

      $('[data-cart-popupclose]').unbind('click');
      $('[data-cart-popupclose]').bind('click',function() {
        me.popup.close();
      });
    },
    "success": function(msg){
      me.popup.show(1,msg);
    },
    "error": function(msg){
      me.popup.show(0,msg);
    },
    "confirm": function(question,callback){
      $("[data-cart-popupmsg]").html(question);
      $.magnificPopup.open({
        items: {
          src: '.popupForm--confirmation'
        },
        type:'inline',
        midClick: true,
        removalDelay: 500,
        mainClass: 'mfp-fade',
        callbacks: {
            beforeOpen: function() {
              this.st.mainClass = $('[data-effect]').attr('data-efect');
            }
        },
      });

      $('[data-confirmation-yes]').unbind('click');
      $('[data-confirmation-yes]').bind('click',function() {
        callback();
      });
      $('[data-confirmation-no]').unbind('click');
      $('[data-confirmation-no]').bind('click',function() {
        me.popup.close();
      });
    },
    "close": function(){
      $.magnificPopup.close();
    }
  };

  this.add = function(data){
        $.post('/cart/add',{'data':data,'_token':window.Laravel.csrfToken},function(response){
          if(typeof response.code !== "undefined"){
            var code = parseInt(response.code);
            me.popup.show(response.code,response.msg);
            if(parseInt(response.code)==1)
              $("[data-cart-counter]").html(response.among);
          }else{
            me.popup.show(window.Laravel.lang.cart.add_error);
          }
        },"json");
  };

  this.remove = function(hash){
    $.post('/cart/remove',{'hash':hash,'_token':window.Laravel.csrfToken},function(response){
      if(response.code == 1){
        $("[data-cart-remove='"+hash+"']").closest('tr').remove();
        me.countSum();
        me.updateCounter();
        me.popup.success(window.Laravel.lang.cart.remove_success);
        if($("tr[data-cart-item]").length==0)
          top.location.reload();
      }else{
        me.popup.error(window.Laravel.cart.remove_failure);
      }
    },"json");
  };

  this.update = function(callback){
    $.post('/cart/update',{'form':$("#cartForm").serialize(),'_token':window.Laravel.csrfToken},function(response){
      callback();
    });
  };

  this.clear = function(){
    $.post('/cart/clear',{'_token':window.Laravel.csrfToken},function(response){
      location.reload();
    });
  };

  this.countSum = function(){
    var sumAll = 0;
    var rows = $("tr").find("[data-price]"),tempPrice;
    for(var i=0;i<rows.length;i++){
      tempPrice = rows.eq(i).html().replace(' ','').replace(',','.');
      sumAll+= parseFloat(tempPrice);
    }
    $("[data-cart-sum]").html(sumAll.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace(".",","));
  };

  this.updateCounter = function(){
    var counter = $("tr[data-cart-item]").length;
    $("[data-cart-counter]").html(counter);
    if(counter==0)
      $(".main__wrapper").html('<div class="main__modules main__modules--border"><p class="formErrors__item formErrors__item--safe">'+window.Laravel.lang.cart.empty+'</p></div>');
  }

  this.bindEvents = function(){
    $("[data-cart-add]").bind('click',function(){
        var thumbnail = $("meta[property='og:image']:last").attr('content');
        var product_id = $("[data-post-id]").attr("data-post-id");
        var params = {
          'id': product_id,
          'thumbnail': thumbnail,
          'among': 1
        };
        me.add(params);
        return false;
    });

    $("[data-cart-addlist]").bind('click',function(){
        var thumbnail = $(this).find('img').attr('src');
        var product_id = $(this).attr("data-cart-addlist");
        var params = {
          'id': product_id,
          'thumbnail': thumbnail,
          'among': 1
        };
        me.add(params);
        return false;
    });

    $("[data-cart-remove]").bind('click',function(){
      var hash = $(this).attr("data-cart-remove");
      var question = window.Laravel.lang.cart.remove_question_1+' ';
      question+= $(this).closest("tr").find("[data-item-name]").attr("data-item-name")+' ';
      question+= window.Laravel.lang.cart.remove_question_2;
      me.popup.confirm(question,function(){
        me.remove(hash);
        me.popup.close();
      })
      return false;
    });

    $("body").on("change","[data-cart] input",function(){
      var value = $(this).val();
      var price = $(this).closest('tr').find("[data-price]").attr('data-price');
      var sum = (value*price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ').replace(".",",");
      $(this).closest('tr').find("[data-price]").html(sum);

      me.countSum();
    });

    $("[data-cart-print]").bind("click",function(){
      if(typeof $(this).attr("href") === "undefined"){
        me.update(function(){
            var lang = $('html').attr('lang');
            $("[data-cart-print]").attr("href","/cart/print?lang="+lang).attr("download","");
            $("[data-cart-print]")[0].click();
        });
      }else{
        setTimeout(function(){
          $("[data-cart-print]").removeAttr("href").removeAttr("download");
        },10);
      }
    });

    $("#cartMailForm").bind('submit',function(){
      $("input[name='products']").val($("#cartForm").serialize());
      return true;
    });

    $('.safe__infoPopup').on('click', function(e){
      e.stopPropagation();
      $(this).removeClass('safe__infoPopup--show');
    });

    $("[data-cart-clear]").bind('click',function(){
      me.popup.confirm(window.Laravel.lang.cart.clear_question,function(){
          me.clear();
          me.popup.close();
      });
      return false;
    });

    /*$("body").on("click","[data-cart-popupamongplus]",function(){
      me.updatePopup(1);
      return false;
    });

    $("body").on("click","[data-cart-popupamongminus]",function(){
      me.updatePopup(-1);
      return false;
    });

    $("#cartOrder").bind("submit",function(){
      if($(this).valid()){
        var result = me.checkRentDates($("input[name='fromLease']").val(),$("input[name='toLease']").val());
        if(!result){
          me.popup.show('cart-info',{msg:"Początkowy czas wynajmu musi być mniejszy lub równy końcowemu"});
          return false;
        }else{
          return true;
        }
      }else{
        return false;
      }
    });*/

  };
};

$(document).ready(function(){
  cart.bindEvents();
});
